// src/components/ContentContainer.js
import React from 'react';

const ContentContainer = ({ children }) => {
  return (
    <div className="content-container">
      {children}
    </div>
  );
};

export default ContentContainer;
